export const PAYMENT_METHODS = Object.freeze({
  CASH_ON_DELIVERY: "Оплата при отриманні",
  ONLINE_CARD: "Оплата карткою онлайн",
  BANK_TRANSFER: "Оплата за реквізитами",
});

export const PAYMENT_CHANNELS = Object.freeze({
  MONOBANK_INVOICE: "monobank_invoice",
  GOOGLE_PAY: "google_pay",
});

export const CHECKOUT_PAYMENT_METHODS = Object.freeze([
  PAYMENT_METHODS.CASH_ON_DELIVERY,
  PAYMENT_METHODS.ONLINE_CARD,
  PAYMENT_METHODS.BANK_TRANSFER,
]);

const normalizePaymentMethod = (value) =>
  String(value || "")
    .trim()
    .toLowerCase()
    .replace(/-/g, "")
    .replace(/\s+/g, " ");

const CASH_ON_DELIVERY_ALIASES = Object.freeze([
  PAYMENT_METHODS.CASH_ON_DELIVERY,
  "Оплата при отриманні у відділені",
  "Оплата при отриманні у відділенні",
]);

export const isCashOnDeliveryPayment = (value) => {
  const normalized = normalizePaymentMethod(value);
  return CASH_ON_DELIVERY_ALIASES.some(
    (method) => normalizePaymentMethod(method) === normalized
  );
};

export const normalizeCheckoutPaymentMethod = (value) =>
  isCashOnDeliveryPayment(value) ? PAYMENT_METHODS.CASH_ON_DELIVERY : value || "";

export const isOnlineCardPayment = (value) =>
  normalizePaymentMethod(value) ===
  normalizePaymentMethod(PAYMENT_METHODS.ONLINE_CARD);
